// src/pages/ServicesPage.js

import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import emailjs from '@emailjs/browser';
import ServicesSection from '../components/ServicesSection';
import ZigZagTimeline from '../components/ZigZagTimeline';
import '../styles/ServicesPage.css';

// PopupAd component
const PopupAd = ({ isVisible, onClose }) => {
  const formRef = useRef();
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        'service_62r2coo',
        'template_a4t97yi',
        formRef.current,
        'B3AZguJeCkvYjwzhh'
      )
      .then(
        () => {
          setSubmitted(true);
          setTimeout(onClose, 3000);
        },
        (error) => {
          console.error('EmailJS error:', error);
        }
      );
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
        >
          <motion.div
            className="popup-content"
            initial={{ scale: 0.8, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 50 }}
            transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="popup-close" onClick={onClose}>✕</button>
            <div className="popup-header">
              <img
                src={require('../assets/images/logo.png')}
                alt="EKS Construction Logo"
                className="popup-logo-image"
              />
              <motion.div
                className="popup-logo"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
              >
                <p>We offer Turnkey and Interior Designing Services!!</p>
              </motion.div>
            </div>
            <motion.div
              className="popup-main-content"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.5 }}
            >
              <h1>
                <span className="popup-highlight">HOME</span><br />
                <span className="popup-highlight">CONSTRUCTION</span><br />
                <span className="popup-highlight">EXPERTS</span><br />
                <span className="popup-location">
                  IN <span className="popup-city">CHENNAI</span>
                </span>
              </h1>
            </motion.div>
            <motion.div
              className="popup-service-text"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.5 }}
            >
              <img
                src={require('../assets/images/ongoing/1/11.jpg')}
                alt="Construction Project"
                className="popup-service-image"
              />
            </motion.div>
            {!submitted ? (
              <motion.form
                ref={formRef}
                className="popup-form"
                onSubmit={handleSubmit}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.0, duration: 0.5 }}
              >
                <div className="popup-form-group">
                  <input
                    type="text"
                    name="user_name"
                    placeholder="Enter your Name"
                    className="popup-input"
                    required
                  />
                </div>
                <div className="popup-form-group">
                  <div className="popup-phone-input">
                    <span className="country-code">🇮🇳 +91</span>
                    <input
                      type="tel"
                      name="user_phone"
                      placeholder="Enter mobile number"
                      className="popup-input phone-input"
                      required
                    />
                  </div>
                </div>
                <div className="popup-form-group">
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Enter your Email ID"
                    className="popup-input"
                    required
                  />
                </div>
                <div className="popup-form-group">
                  <input
                    type="text"
                    name="location"
                    placeholder="Enter your Location"
                    className="popup-input"
                    required
                  />
                </div>
                <div className="popup-form-group">
                  <input
                    type="number"
                    name="user_location"
                    placeholder="Enter Total Land area"
                    className="popup-input"
                    required
                  />
                </div>
                <motion.button
                  type="submit"
                  className="popup-submit-btn"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  GET FREE QUOTE
                </motion.button>
              </motion.form>
            ) : (
              <motion.div
                className="popup-success-message"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                <h2>Thank You!</h2>
                <p>Your quote request has been sent. We’ll contact you soon.</p>
              </motion.div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

// ServicesPage component
const ServicesPage = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      {/* Page Hero */}
      <motion.section
        className="services-hero"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        <div className="services-hero-container">
          <h1>Our Construction Services</h1>
          <p>Comprehensive construction solutions to make your dreams reality</p>
        </div>
      </motion.section>

      {/* Services Section */}
      <ServicesSection />

      {/* Timeline */}
      <ZigZagTimeline />

      {/* Popup Ad */}
      <PopupAd isVisible={showPopup} onClose={closePopup} />
    </motion.div>
  );
};

export default ServicesPage;
